import { defineComponent as _defineComponent } from 'vue'
import { onUnmounted, reactive, withDefaults } from 'vue';

export type StrokeStyle = 'solid' | 'dashed';

interface Props {
  map: google.maps.Map;
  path: google.maps.MVCArray<google.maps.LatLng>;
  strokeColor?: string;
  strokeOpacity?: number;
  strokeWeight?: number;
  strokeStyle?: StrokeStyle;
  geodesic?: boolean;
  visible?: boolean;
  zIndex?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleMapsLine',
  props: {
    map: null,
    path: null,
    strokeColor: { default: '#555555' },
    strokeOpacity: { default: 1 },
    strokeWeight: { default: 2 },
    strokeStyle: { default: 'solid' },
    geodesic: { type: Boolean, default: true },
    visible: { type: Boolean, default: true },
    zIndex: { default: 10 }
  },
  setup(__props: any) {

const props = __props as { map: google.maps.Map, path: google.maps.MVCArray<google.maps.LatLng>, strokeColor: string, strokeOpacity: number, strokeWeight: number, strokeStyle: StrokeStyle, geodesic: boolean, visible: boolean, zIndex: number }



// Define a symbol using SVG path notation for dashed lines
const dashSymbol = {
  path: 'M 0,-1 0,1',
  strokeOpacity: props.strokeOpacity,
  scale: props.strokeWeight,
};

const line = reactive<google.maps.Polyline>(
  new google.maps.Polyline({
    path: props.path,
    strokeColor: props.strokeColor,
    strokeOpacity: props.strokeStyle === 'dashed' ? 0 : props.strokeOpacity,
    strokeWeight: props.strokeWeight,
    map: props.map,
    geodesic: props.geodesic,
    visible: props.visible,
    zIndex: props.zIndex,
    icons:
      props.strokeStyle === 'solid'
        ? []
        : [
            {
              icon: dashSymbol,
              offset: '0',
              repeat: '20px',
            },
          ],
  }),
);

/* LIFECYCLE */

onUnmounted(() => {
  line.setMap(null);
});

return { __sfc: true,props, dashSymbol, line }
}

})